import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

class ErrorBoundaryRoutes extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    //console.log(error);
    return { hasError: true };
  }

  componentDidCatch(er, errorInfo) {
    // You can also log the error to an error reporting service
    // console.log(er);
    // console.log(errorInfo);

    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/elog/add`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: {
        error_log: JSON.stringify({ errorinfo: errorInfo, error: er }),
        page: this.props.page,
        route: this.props.route,
      },
    };
    axios(config)
      .then(function (response) {})
      .catch(function (error) {});
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <CustomErrorPage mesg="Something went Wrong" route={this.props.route} />
      );
    }

    return this.props.children;
  }
}

const CustomErrorPage = ({ mesg, route }) => {
  let navigate = useNavigate();
  //  let navigate = useNavigate();
  // const handleClick = () => {
  //   if (localStorage.getItem("token")) {
  //     navigate(route, { replace: true });
  //   }
  // };
  return (
    <>
      <p>{mesg}</p>
      <p>
        <button
          className="px-4 py-2 font-bold text-white bg-blue-700 rounded hover:bg-blue-500"
          onClick={() => navigate(route)}
        >
          Click here
        </button>
      </p>
    </>
  );
};

export default ErrorBoundaryRoutes;
